import { render, staticRenderFns } from "./Markedsinfo.vue?vue&type=template&id=8d764324&"
import script from "./Markedsinfo.vue?vue&type=script&lang=js&"
export * from "./Markedsinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports